import { AUTH_TOKEN_KEY, AUTH_USER_ID } from '../constants';

/**
 * @description casts object to url query params
 * @param {Object} obj generic object to cast
 * @returns {String} string of query params from object
 */
export const toQueryParams = obj => (
  Object.entries(obj).map(([key, value]) => {
    return `${key}=${value}`;
  }).join('&')
);

/**
 * @description casts query params string to object of values
 * @param {String} str generic object to cast
 * @returns {Object} object of params
 */
export const fromQueryParams = str => (
  str.replace('?', '').split('?').reduce((acc, curr) => ({
    ...acc,
    [curr.split('=')[0]]: curr.split('=')[1],
  }), {})
);

/**
 * @description retrieves user auth token from local storage
 * @returns {String} auth token
 */
export const getAuthTokenFromStorage = () => localStorage.getItem(AUTH_TOKEN_KEY);

/**
 * @description retrieves user id from local storage
 * @returns {String} user id
 */
export const getUserIdFromStorage = () => localStorage.getItem(AUTH_USER_ID);

/**
 * @description capitalizes each word in a string sentence
 * @param {String} str string to modify
 */
export const capitalizeEachWord = (str = '') => (
  str.split(' ').map(word => (word[0] || '').toUpperCase() + (word || '').substring(1)).join(' ')
);

/**
 * @description lowercases each word in a string sentence
 * @param {String} str string to modify
 */
export const lowerCaseEachWord = str => (
  str.split(' ').map(word => word[0].toLowerCase() + word.substring(1)).join(' ')
);

// set up ability to generate predictable random numbers
// adopted from: http://indiegamr.com/generate-repeatable-random-numbers-in-js/
Math.seed = 6;
Math.seededRandom = (max, min) => {
  const thisMax = max || 1;
  const thisMin = min || 0;

  Math.seed = (Math.seed * 9301 + 49297) % 233280;
  const rnd = Math.seed / 233280;

  return thisMin + rnd * (thisMax - thisMin);
};

export const SEEDED_RANDOM_INTS = Array.from(Array(100).keys()).map(() => Math.seededRandom(0.1, 0));
